// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Instructor_wrapper__hLgm9","textWrapper":"Instructor_textWrapper__OR8ZB","headline":"Instructor_headline__YQMQm","image":"Instructor_image___TykD"};